import { render } from "./cities-report.vue?vue&type=template&id=ef5e5450&scoped=true"
import script from "./cities-report.vue?vue&type=script&lang=js"
export * from "./cities-report.vue?vue&type=script&lang=js"

import "./cities-report.vue?vue&type=style&index=0&id=ef5e5450&scoped=true&lang=css"

import exportComponent from "/Users/girgisnabil/Documents/projects/home-food-plus-full-stack/source/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef5e5450"]])

export default __exports__